<template>
    <div
        class="md-house layout6 mg-bg"
        :style="{ ...spaceStyle, ...colorStyle, background: bgColor  }"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <div class="house-container f-col" :class="{ pc: !isMobileSize }">
            <div class="title-wrap">
                <site-title
                    :title="title"
                    class="house-title"
                ></site-title>
                <site-sub-title
                    class="desc"
                    :size="16"
                    :mbSize="16"
                    :title="desc"
                ></site-sub-title>
            </div>
            <list />
            <div class="btn-box">
                <div class="button-swiper" v-if="showSwiperBtn">
                    <div class="house-prev layout6">
                        <i class="iconfont icon-arrow-up prev-el"></i>
                    </div>
                    <div class="house-next layout6">
                        <i class="iconfont icon-arrow-up next-el"></i>
                    </div>
                </div>
                <site-button
                    v-if="moreShow && moreText"
                    :html="moreText"
                    class="view-all-listings-btn"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    rel="noopener noreferrer"
                ></site-button>
            </div>
        </div>
    </div>
</template>
<script>
import Core from '../index.js';
import list from './list.vue';
export default {
    mixins: [Core],
    components: { list },
    computed: {
        showSwiperBtn() {
            if (this.isMobileSize) {
                return; 
            }
            let len = this.result.listings.length;
            if (window.innerWidth > 1000) {
                return len > 4;
            } else {
                return len > 3;
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-house.layout6 {
    .house-container {
        position: relative;

        .title-wrap {
            margin-bottom: 40px;
            .desc {
                margin-top: 10px;
                
            }
            @include media-800 {
                margin-bottom: 20px;
            }
        }
    }
    .swiper {
        height: 520px;
        .swiper-wrapper {
            .swiper-slide {
                width: 350px;
                height: 520px;
                margin-right: 50px;
                transition: all 0.3s ease;
            }
            .swiper-slide.swiper-slide-active ~ .swiper-slide {
                width: calc((100% - 400px - 30px) / 3);
                height: 450px;
                margin-right: 15px;

                @media (max-width: 1000px) {
                    width: calc((100% - 400px - 15px) / 2);
                }

                &:last-child {
                    margin-right: 0;
                }
            }
            .swiper-slide.swiper-slide-active {
                .house-slider-item.layout6 {
                    border: none;
                    padding: 0;
                    > article {
                        position: relative;
                    }
                    .house-imgs {
                        height: 100%;
                    }
                    .house-info {
                        justify-content: flex-end;
                        height: 266px;
                        padding: 20px;
                        background: linear-gradient(
                            180deg,
                            rgba(25, 25, 25, 0) 0%,
                            rgba(25, 25, 25, 0.8) 100%
                        );
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        z-index: 2;
                        color: #fff;

                        .house-price-wrap {
                            .house-sold-price,
                            .house-price {
                                color: #fff;
                            }
                            .house-initial-price {
                                color: rgba(255, 255, 255, 0.7);
                            }
                        }
                        .address,
                        .detail {
                            margin-top: 10px;
                            color: rgba(255, 255, 255, 0.8);
                        }
                        .detail {
                            .vertical-line:after {
                                color: rgba(255, 255, 255, 0.8);
                            }
                        }

                        .mls-box {
                            .house-mls-id,
                            .desc {
                                color: rgba(255, 255, 255, 0.5);
                            }
                            .house-mls-logo {
                                height: 20px;
                            }
                        }
                    }
                }
            }
            .swiper-slide.house-placeholder {
                .house-slider-item.layout6 {
                    .house-imgs {
                        background: rgba(218, 218, 218, 0.2);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img {
                            width: 64px;
                            height: 56px;
                            &:hover {
                                transform: scale(1);
                            }
                        }
                    }
                    .house-info {
                        div {
                            background: rgba(218, 218, 218, 0.2);
                        }
                        .house-price-wrap {
                            height: 30px;
                        }
                        .detail,
                        .address {
                            width: calc(100% - 60px);
                            height: 20px;
                            margin-top: 10px;
                        }
                        .mls-box {
                            height: 15px;
                            margin-top: 20px;
                        }
                    }
                }
            }
        }
    }
    .btn-box {
        width: calc(100% - 400px);
        height: 50px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 10;

        .button-swiper {
            float: left;
            width: 130px;
            height: 50px;
            display: flex;
            justify-content: space-between;
            .house-next,
            .house-prev {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                border: 1px solid var(--g-btn-background);
                display: flex;
                align-items: center;
                justify-content: center;
                color: var(--g-btn-background);
                transform: rotate(90deg);
                cursor: pointer;
                .iconfont {
                    font-size: 20px;
                }
                &:hover::after {
                    content: '';
                    background: rgba(25, 25, 25, 0.1);
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
                &.house-swiper-disabled,
                &.swiper-button-lock {
                    cursor: not-allowed;
                    opacity: 0.3;
                    &:hover::after {
                        content: '';
                        background: transparent;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }
                }
                &.house-prev {
                    transform: rotate(-90deg);
                    margin-right: 30px;
                }
            }
        }
        .view-all-listings-btn {
            float: right;
            text-align: center;
            color: var(--g-btn-color);
            background: var(--g-btn-background);
            height: 50px;
            line-height: 50px;
            width: 200px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            padding: 0 15px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
        }

        @include media-800 {
            width: 100%;
            position: static;
            .view-all-listings-btn {
                float: none;
                margin: 0 auto;
            }
        }
    }
}
</style>
